<template>
  <el-container class="container">
    <div class="home_content_main">
      <el-row class="home_site_summary">
        <span>已开放数据集：</span>
        <count-to :start-val="0" :end-val="stats.datasets" :duration="1500" class="highlight_num" />
        <span> 个数据集</span>
      </el-row>
      <el-row class="home_search_part">
        <search @search="onSearch"></search>
      </el-row>
      <div class="home_data_category">
        <div class="home_data_category_sub">
          <h2><i class="el-icon-coin"></i> 主题</h2>
          <div v-for="i in Math.ceil(categories.length/4)" :key="i">
            <el-row>
              <el-col v-for="(cate, cate_i) in categories.slice((i-1)*4,i*4)" :span="6" :key="cate_i">
                <div @click="onCategoryClick(cate)" class="wow fadeIn animated">
                  <a href="javascript:void(0);" ><img :src="cate.icon"></a>
                  <h4>{{cate.title}}</h4>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="home_data_category_sub">
          <h2><i class="el-icon-map-location"></i> 省/自治区/直辖市</h2>
          <el-row class="wow fadeInLeft animated">
            <el-col v-for="(pro, pro_i) in provinces" :span="6" :key="pro_i">
              <el-button plain @click="onProvinceClick(pro.code)" icon="el-icon-place" class="city_btn">{{ pro.name }}</el-button>
            </el-col>
          </el-row>
        </div>
        <div>
          <a
            class="home-demand-link"
            :href="demandStationUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>找不到你要的数据？</span>
            <span>点击提交需求</span>
          </a>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import {WOW} from 'wowjs'
import CountTo from 'vue-count-to'
import {getStatsDatasets} from '@/api/homepage'
import {getProvinces, points} from '@/api/search'
import Search from '@/pages/common/Search'

export default {
  name: 'HomeMain',
  components: {
    CountTo,
    Search
  },
  data () {
    return {
      searchInput: '',
      categories: [
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/jiaotong.png'),
          'title': '交通出行',
          'keyword': '交通出行'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/weisheng.png'),
          'title': '卫生健康',
          'keyword': '卫生健康'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/gongshang.png'),
          'title': '经贸工商',
          'keyword': '经贸工商'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/shehui.png'),
          'title': '社会民生',
          'keyword': '社会民生'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/jiaoyu.png'),
          'title': '教育科技',
          'keyword': '教育科技'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/gonggong.png'),
          'title': '公共安全',
          'keyword': '公共安全'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/caishui.png'),
          'title': '财税金融',
          'keyword': '财税金融'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/shebao.png'),
          'title': '社保就业',
          'keyword': '社保就业'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/ziyuan.png'),
          'title': '资源环境',
          'keyword': '资源环境'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/building.png'),
          'title': '城建住房',
          'keyword': '城建住房'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/nongye.png'),
          'title': '农业农村',
          'keyword': '农业农村'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/wenhua.png'),
          'title': '文化休闲',
          'keyword': '文化休闲'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/xinyong.png'),
          'title': '信用服务',
          'keyword': '信用服务'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/jigou.png'),
          'title': '机构团体',
          'keyword': '机构团体'
        },
        {
          'link': '#',
          'icon': require('@/assets/images/data_cate_icon/qita.png'),
          'title': '其他',
          'keyword': '其他'
        }
      ],
      demandStationUrl: 'https://jsj.top/f/WNLWeF',
      provinces: [],
      stats: {
        datasets: 0,
        provinces: 0,
        cities: 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const wow = new WOW({
        live: false
      })
      wow.init()
    })
    getStatsDatasets().then(({data}) => {
      this.stats.datasets = data
    })
    getProvinces({}).then(({data}) => {
      this.provinces = data
    })
    points()
  },
  methods: {
    onSearch (query) {
      var location = { path: '/dataset', query: query }
      this.$router.push(location)
    },
    onCategoryClick (category) {
      var location = { path: '/dataset', query: { subject: [category.keyword] } }
      this.$router.push(location)
    },
    onProvinceClick (provinceCode) {
      var location = { path: '/dataset', query: { province: provinceCode } }
      this.$router.push(location)
    }
  }
}
</script>

<style scoped>
.container {
  background: #f7f7f7;
  padding: 5px;
  color: #515151;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.el-container p {
  line-height: 1.5;
  text-align: justify;
}

.img-box {
  padding: 2rem 0;
}

.img-box img {
  height: 30rem;
  width: 100%;
}

.home_site_summary {
  width: 100%;
  margin: 15px 10px;
}

.home_site_summary .highlight_num {
  color: red;
  font-weight: normal;
  font-size: 30px;
}

.home_site_summary span {
  font-size: 20px;
  font-weight: normal;
}

.home_search_part {
  width: 90%;
  text-align: left;
  margin: 20px auto;
  background: #fff;
  padding: 50px 20px;
  border-radius: 4px;
}

.home_search_part /deep/ input {
  height: 50px;
}

.home_search_part button {
  height: 50px;
  font-weight: bold;
}

.home_content_main {
  width: 80%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.home_data_category {
  width: 90%;
  margin: 30px auto 60px auto;
  text-align: center;
  padding: 20px;
}

.home_data_category_sub {
  width: 100%;
  background: #fff;
  margin-top: 20px;
  padding: 5px 0 30px 0;
  border-radius: 4px;
}

.home_data_category_sub img {
  width: 80px;
  margin-top: 5px;
}

.home_data_category_sub h2 {
  font-size: 26px;
  padding-bottom: 13px;
  border-bottom: 1px solid #eeeeee;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.home_data_category_sub h4 {
  font-size: 14px;
}

.city_btn {
  width: 80%;
  margin: 5px 10px;
}

.home-demand-link {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: fit-content;
  margin: 30px auto 0;
  padding: 8px 55px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  box-shadow: 0 10px 24px rgba(71, 199, 232, 0.24);
  background-color: rgb(0, 111, 111);
}

.home-demand-link span:first-child {
  white-space: nowrap;
}

</style>



// WEBPACK FOOTER //
// src/pages/homepage/components/HomeContent.vue